import React, {useEffect} from 'react';

import axios from "axios";

function FindPasswordPage(props){
  return (
    <>
    </>
  );
}

export default FindPasswordPage;
